import ClientAppSidebar from "../../../../components/ClientAppSidebar";
import {
  CurrentBalanceSection,
  BankAccountsSection,
  WeeklyCashMovementSection,
  RecentBankTransactionsSection,
  ReconciliationStatusSection,
} from "../components/cash_components";

/**
 * Cash & Bank page. Design-only with mock data; hooks and API integration to follow.
 * Sections: Current Balance, Bank Accounts, Weekly Cash Movement, Recent Transactions, Reconciliation Status.
 */
export default function CashAndBankPage() {
  return (
    <div className="flex w-full items-start h-screen">
      <ClientAppSidebar />
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 self-stretch bg-default-background overflow-y-auto">
        <div className="container max-w-nne flex w-full grow shrink-0 basis-0 flex-col items-start gap-8 bg-neutral-50 py-12 overflow-auto">
          <div className="flex w-full flex-col items-start gap-1">
            <span className="text-heading-1 font-heading-1 text-default-font">
              Cash & Bank
            </span>
            <span className="text-body font-body text-subtext-color">
              See your cash across bank accounts and track what's happening in
              real time.
            </span>
          </div>
          <BankAccountsSection />
          <CurrentBalanceSection />
          <WeeklyCashMovementSection />
          <RecentBankTransactionsSection />
          <ReconciliationStatusSection />
        </div>
      </div>
    </div>
  );
}
